import Home from "../../views/administrador/Home";



///----------VENTAS----------------
import Entrega from "../../views/administrador/Ventas/Entrega";

//----------PRODUCCION-------------
import ControlTiemposMuertos from "../../views/administrador/Produccion/ControlTiemposMuertos";

//----------COMPRAS-------------
import Solicitud_Compras_Servicio from "../../views/administrador/Compras/Solicitud_Compras_Servicio";
import Solicitud_Compras from "../../views/administrador/Compras/Solicitud_Compras";

//----------AUTORIZACIOINES-------------
import Autorizaciones_compras from "../../views/administrador/Autorizaciones/Autorizaciones_compras";

//----------LOGISTICA-------------
import Interface from "../../views/administrador/Logistica/Interface";
import AutorizarOTs from "../../views/administrador/Logistica/AutorizarOTs";
import EntregaCombustible from "../../views/administrador/Logistica/EntregaCombustible";
import CtrlCombustibleExtCartelera from "../../views/administrador/Logistica/CtrlCombustibleExtCartelera";
import CtrlCombustibleExtFacturacion from "../../views/administrador/Logistica/CtrlCombustibleExtFacturacion";
import FfactSAP from "../../views/administrador/Logistica/FfactSAP";



const FinanzasRoutes = [
  {
    path: "/home",
    name: "Home",
    icon: "pe-7s-home",
    component: Home,
    id: "1",
  },

  // --------------- Ventas -------------
  {
    path: 3,
    name: "Ventas",
    icon: "pe-7s-credit",
    id: "3",
    component: [
      {
        path: "/Entrega",
        name: "Entrega",
        icon: "",
        component: Entrega,
        doNotShow: true,
        id: "3",
        grupoDependiente: 3,
      },     
    ],
  }, 
  
  // --------------- Produccion -------------
  {
    path: 2,
    id: "2",
    name: "Produccion",
    icon: "pe-7s-box1",
    component: [
      {
        path: "/ControlTiemposMuertos",
        name: "Tiempos Muertos",
        icon: "",
        component: ControlTiemposMuertos,
        doNotShow: true,
        id: "2",
        grupoDependiente: 2,
      },   
       
     
    ],
  },
  
  // --------------- Compras  -------------
  {
    path: 11,
    name: "Compras",
    icon: "pe-7s-cart",
    id: "11",
    component: [
      {
        path: "/Solicitud_Compras_Servicio",
        name: "Solicitud Compras Servicio",
        icon: "",
        component: Solicitud_Compras_Servicio,
        doNotShow: true,
        id: "1001",
        grupoDependiente: 11,
      },     
      {
        path: "/Solicitud_Compras",
        name: "Solicitud de Compras",
        icon: "",
        component: Solicitud_Compras,
        doNotShow: true,
        id: "1002",
        grupoDependiente: 11,
      },  
    ],
  },

   // --------------- Autorizaciones  -------------
   {
    path: 12,
    name: "Autorizaciones Compras",
    icon: "pe-7s-like2",
    id: "12",
    component: [
      {
        path: "/Autorizaciones_compras",
        name: "Autorizaciones Compras",
        icon: "",
        component: Autorizaciones_compras,
        doNotShow: true,
        id: "2001",
        grupoDependiente: 12,
      },     
    ],
  },
  {
    path: 13,
    name: "Logistica",
    icon: "pe-7s-map",
    id: "13",
    component: [
      {
        path: "/Interface",
        name: "Interface",
        icon: "",
        component: Interface,
        doNotShow: true,
        id: "3001",
        grupoDependiente: 13,
      },
      {
        path: "/AutorizarOTs",
        name: "Autorizar OTs",
        icon: "",
        component: AutorizarOTs,
        doNotShow: true,
        id: "3002",
        grupoDependiente: 13,
      },       
      {
        path: "/EntregaCombustible",
        name: "Despacho Combustible",
        icon: "",
        component: EntregaCombustible,
        doNotShow: true,
        id: "3003",
        grupoDependiente: 13,
      },  
      {
        path: "/CtrlCombustibleExtCartelera",
        name: "Control Combustible Externos Cartelera",
        icon: "",
        component: CtrlCombustibleExtCartelera,
        doNotShow: true,
        id: "3004",
        grupoDependiente: 13,
      },    
      {
        path: "/CtrlCombustibleExtFacturacion",
        name: "Control Combustible Externos Facturacion",
        icon: "",
        component: CtrlCombustibleExtFacturacion,
        doNotShow: true,
        id: "3005",
        grupoDependiente: 13,
      },  
       {
        path: "/FfactSAP",
        name: "Ingresar Factura FFACSA",
        icon: "",
        component: FfactSAP,
        doNotShow: true,
        id: "3006",
        grupoDependiente: 13,
      },  
    ],
  },
];
export default FinanzasRoutes;
